import ErrorString from './error_string';

export default function Select(props)
{
    const {
        children,
        className,
        error,
        id,
        name,
        onChange,
        required,
        value
    } = props

    return (
        <>
            <select
                id={ id }
                name={ name }
                value={ value }
                required={ required }
                className={ "block w-full bg-white border-grey-2 rounded-sm focus:border-bb focus:ring-bb" + (className ? " " + className : "") }
                onChange={ onChange }
                >
                { children }
            </select>
            <ErrorString error={ error } />
        </>
    );
}